export const SET_STEP = "SET_STEP";
export const SAVE_STEP_DATA = "SAVE_STEP_DATA";
export const RESET_FORM = "RESET_FORM";
